
import Register from "./components/Register";
import Login from "./components/Login";
import Products from "./components/Products";
// import ipConfig from "./ipConfig.json";
import Cart  from "./components/Cart";
import Thanks from "./components/Thanks";
// import Footer from "./components/Footer"
import Checkout from "./components/Checkout"
import { BrowserRouter, Switch, Route } from "react-router-dom";


export const config = {
  endpoint: `https://qkart-frontend-7ait.onrender.com/api/v1`,
};

function App() {
  return (
    <BrowserRouter>
   <div className="App">
      <Switch>
       
        <Route exact path="/" component={Products} />

        {/* Register page at "/register" */}
        <Route exact path="/register" component={Register} />

        {/* Login page at "/login" */}
        <Route exact path="/login" component={Login} />
        <Route exact path="/cart" component={Cart} />
        <Route exact path="/checkout" component={Checkout} />
        <Route exact path="/thanks" component={Thanks} />

        <Route component={() => <h2>404 - Page Not Found</h2>} />
        
      </Switch>
    </div>
    </BrowserRouter>
  );
}

export default App;
